import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;

    constructor(private http: HttpClient) {
    }

    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        return getFirebaseBackend().loginUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return this.http.post<any>(environment.url + environment.Authenticate + environment.forgotPassword, { email })

    }

    restorepassword(obj:any){
        return this.http.post<any>(environment.url + environment.Authenticate + environment.resetPassword,obj)
    }

    validateCode(token:string){
        return this.http.get<any>(environment.url + environment.Authenticate + environment.validateToken + '?token='+token)
    }


    validateCreditUser(objCreditUser:any){
        return this.http.get<any>(environment.url + environment.Credit + environment.getPendingPayments + '?documentNumber='+objCreditUser.documentNumber+'&creditId='+objCreditUser.creditId)
    }

    createPayment(value, creditId){
        return this.http.post<any>(environment.url + environment.Cobre + environment.createPayment+'?value='+value+'&creditId='+creditId,null)
    }

    getUserPublic(userId){
        return this.http.get<any>(environment.url + environment.User + '/get/public?id='+userId)
    }
    
    /**
     * Logout the user
     */
    // logout() {
    //     // logout the user
    //     getFirebaseBackend().logout();
    // }
}

